import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getActiveTabFromLocalStorage } from "@/ui/TabsComponent/TabsComponent";

import { Page } from "@/ui/Layout/Page";
import { TabsComponent } from "@/ui/TabsComponent";
import Button from "@/ui/Button";
import { ButtonTypes, Variants } from "@/ui/types";
import { DashboardPage } from "@/Apps/Dashboards/DashboardPage";
import { getCampaign } from "@/api/campaigns";
import { Settings } from "@/Apps/Dashboards/Settings/Settings";
import { getSessionToken } from "@/api/auth";
import { PublishCampaignModal } from "../Funnels/Popups/PublishCampaignModal";

import { ContactsGallery } from "@/Apps/CRM/ContactsGallery";
import { getFilterObject } from "@/Apps/CRM/scripts";

export const Dashboard = ({ name = "" }) => {
  const [activeTab, setActiveTab] = useState(getActiveTabFromLocalStorage() || "overview");
  const [partnershipProgramData, setPartnershipProgramData] = useState<{
    name?: string;
  }>({ name: "" });
  const [isPublishPopupOpen, setIsPublishPopupOpen] = useState(false);
  // const [activePageId, setActivePageId] = useState(null);
  const { id } = useParams();

  // Fetch the campaign data from the API when the component mounts
  useEffect(() => {
    const token = getSessionToken();

    (async () => {
      const data = await getCampaign({ token, id });
      setPartnershipProgramData(data);
    })();
  }, []);

  // Use this to configure what shows in the top bar of the page
  const topBarSettings = {
    page: [
      { label: name, href: "/partnerships" },
      { label: partnershipProgramData.name || "" },
    ],
    items: (
      <Button
        label="Publish Campaign"
        onClick={() => setIsPublishPopupOpen(true)}
        type={ButtonTypes.OUTLINED}
        variant={Variants.INFO}
      />
    ),
  };

  return (
    <Page topBar={topBarSettings}>
      {/* Render the publish campaign modal if it's set to open */}
      {isPublishPopupOpen && (
        <PublishCampaignModal
          setIsOpen={setIsPublishPopupOpen}
          campaignId={id}
          unitName="Program"
        />
      )}
      <div className={`p-6 w-full`}>
        <div className="tabs flex flex-col">
          <TabsComponent
            tabs={[
              { label: "Dashboard", value: "overview" },
              { label: "Resources & Assets", value: "media" },
              { label: "Customize", value: "customize" },
              { label: "Payouts", value: "payouts" },
              { label: "Automation", value: "automation" },
              { label: "Partners", value: "crm" },
              { label: "Program Settings", value: "settings" },
            ]}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            actionSection={false}
          />
          {activeTab === "overview" && (
            <DashboardPage
              campaignData={partnershipProgramData}
              unitName="partnership"
              // panelTitle="Pages in this program"
              widgets={["kpi", "tracking", "media"]}
            />
          )}
          {activeTab === "media" && (
            <DashboardPage
              campaignData={partnershipProgramData}
              unitName="partnership"
              // panelTitle="Pages in this program"
              widgets={["media"]}
            />
          )}
          {activeTab === "customize" && (
            <DashboardPage
              campaignData={partnershipProgramData}
              unitName="partnership"
              // panelTitle="Pages in this program"
              widgets={["customize"]}
            />
          )}
          {activeTab === "payouts" && (
            <DashboardPage
              campaignData={partnershipProgramData}
              panelTitle="Payouts"
              widgets={["affiliatePayouts"]}
            />
          )}
          {activeTab === "automation" && (
            <DashboardPage
              campaignData={partnershipProgramData}
              widgets={["automation"]}
            />
          )}
          {activeTab === "crm" && (
            <ContactsGallery
              onCreate={() => {}}
              defaultFilter={getFilterObject({
                field: "hiddenTags",
                operator: "contains",
                value: id,
              })}
            />
          )}
          {activeTab === "settings" && (
            <Settings
              campaignData={partnershipProgramData}
              setCampaignData={setPartnershipProgramData}
              unitName="Partnership Program"
              widgets={[
                "name",
                "affiliateCommissionSettings",
                "affiliatePaymentTypes",
                "domain",
                "delete",
              ]}
              // hasScriptsAndTracking={false}
            />
          )}
        </div>
      </div>
    </Page>
  );
};
